import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import '../index.scss';

export default class BookerAccountInfo extends React.Component {
  constructor(props) {
    super(props);

    // const { business } = this.props;

    this.state = {
      zenotiAccount: '',
      ZenotiAPIKey: '',
      terminalId:'',
      merchantId:'',
      subdomainCheck:false,
      subdomainName:'',
      mandatoryFieldError: false,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.validate = this.validate.bind(this);
  }

  onInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  onCheckBoxToggle=()=>{
    const { subdomainCheck } =  this.state;
    this.setState({
      subdomainCheck:!subdomainCheck
    })
  }
  onNextButtonClick() {
    const { zenotiAccount, ZenotiAPIKey, terminalId,merchantId, subdomainCheck, subdomainName} = this.state;

    const data = {
      account: zenotiAccount,
      apiKey: ZenotiAPIKey,
      GTID:terminalId,
      GMID:merchantId,
      client: 'MYTIME',
      ...(subdomainCheck && {sub_domain:subdomainName})
    };
    const validationResult = this.validate(data);

    if (validationResult) {
      this.props.postZenotiAccountInfo(data);
    }
  }

  validate(data) {
    const { subdomainCheck, subdomainName} = this.state;
    if (!data.account) {
      this.setState({
        mandatoryFieldError: true,
      });

      return false;
    }
    if (subdomainCheck && subdomainName.trim().length===0) {
      this.setState({
        mandatoryFieldError: true,
      });

      return false;
    }

    this.setState({
      mandatoryFieldError: false,
    });

    return true;
  }

  render() {
    const { zenotiAccount, ZenotiAPIKey, mandatoryFieldError,terminalId,merchantId, subdomainCheck , subdomainName} = this.state;
    const { softwares } = this.props;
    console.log('subdomainCheck',subdomainCheck)
    return (
      <div className="authorize-access">
        <form className="authorize-access__form">
          {mandatoryFieldError ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Fields marked in red are mandatory!
            </p>
          ) : null}
          {softwares.isBookerAccountInfoSaveFail ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Unable to save account information
            </p>
          ) : null}
          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">Enter your MyTime Company Id*</p>
            <input
              type="text"
              name="zenotiAccount"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={zenotiAccount}
              onChange={this.onInputChange}
              autoComplete="false"
            />
          </div>

          {/* <p className="authorize-access_hint">
                  Hint: Your Zenoti Account Name is the same as the leading
                  part of the URL for your Zenoti online account
          </p> */}

          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">Enter a unique MyTime API Key</p>
            <input
              type="text"
              name="ZenotiAPIKey"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={ZenotiAPIKey}
              onChange={this.onInputChange}
              autoComplete="false"
            />
          </div>

          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">Enter MyTime Merchant Id</p>
            <input
              type="text"
              name="merchantId"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={merchantId}
              onChange={this.onInputChange}
              autoComplete="false"
            />
          </div>

          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">Enter MyTime Terminal Id</p>
            <input
              type="text"
              name="terminalId"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={terminalId}
              onChange={this.onInputChange}
              autoComplete="false"
            />
          </div>
          <div className="authorize-access__form__row form-group checkbox-row">
            <input
              type="checkbox"
              name="subdomainCheck"
              className={classnames({ 'has-error': mandatoryFieldError })}
              defaultChecked={subdomainCheck}
              onChange={this.onCheckBoxToggle}
              autoComplete="false"
            />
            <label for="subdomainCheck" className="form-group__heading">Are you managing your infrastructure and have a subdomain?</label>
          </div>
          {subdomainCheck && 
          <div className="authorize-access__form__row form-group checkbox-row">
            https://
            <input
              type="text"
              name="subdomainName"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={subdomainName}
              onChange={this.onInputChange}
              autoComplete="false"
            />
            .mytime.com
          </div>
          }
          {/* <p className="authorize-access_hint">
            Hint: You can find instrutions on how to generate an API key by going to the
            following link and referring to the Overview section.
            <a className="authorize-access__help-text" href="https://docs.zenoti.com/?version=latest#intro" target="_blank">
                  https://docs.zenoti.com/?version=latest#intro
            </a>
          </p> */}

        </form>
        <div className="authorize-access__actions">
          <button className="btn btn--secondary btn--lg" type="button" onClick={this.props.onBackClick}>
            Previous
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={this.onNextButtonClick}
            disabled={softwares.isSavingBookerAccountInfo}
          >
            {!softwares.isSavingBookerAccountInfo ? 'Next' : 'Saving...'}
          </button>
        </div>
      </div>
    );
  }
}

BookerAccountInfo.defaultProps = {
  postZenotiAccountInfo: () => {},
  onBackClick: () => {},
};

BookerAccountInfo.propTypes = {
  postZenotiAccountInfo: PropTypes.func,
  onBackClick: PropTypes.func,
  softwares: PropTypes.shape().isRequired,
};
